<script lang="ts">
  import Dropdown from "$app/components/Dropdown.svelte"
  import { appStore } from "$app/store.svelte"
  import {
    SquarePen,
    Users,
    Lock,
    Trophy,
    Calculator,
    CirclePlus,
    LogOut
  } from "lucide-svelte"

  let openDropdown = $state(false)
</script>

<Dropdown bind:open={openDropdown}>
  {#snippet button()}
    <span
      data-name="nav-button"
      class="rounded-full flex items-center justify-center"
    >
      <img
        src={appStore.current_user?.avatar_thumb_url}
        class="h-10 w-10 rounded-full current-user-avatar hover:border-indigo-300 p-0.5 hover:border hover:shadow"
        alt={appStore.current_user?.name}
      />
    </span>
  {/snippet}
  <div class="relative">
    <div
      class="origin-top-right absolute right-0 mt-1 w-72 rounded-md shadow-lg py-1 bg-white ring-1 ring-gray-300 ring-opacity-5 z-50"
    >
      <div
        class="group flex items-center justify-center px-4 py-3 border-b border-gray-400 bg-gray-10"
      >
        <img
          src={appStore.current_user.avatar_thumb_url}
          class="h-6 w-6 rounded-full shadow mr-2"
          alt={appStore.current_user.name}
        />
        <p class="text-sm font-bold text-black overflow-hidden text-ellipsis">
          {appStore.current_user.email}
        </p>
      </div>
      {#if appStore.current_user.id === 1183}
        <a
          href="https://familywithpurpose.com/dashboard/41"
          target="_blank"
          rel="noopener noreferrer"
          class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
        >
          <Users class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500" />
          Family Plan
        </a>
      {/if}

      <a
        href={`/certifications`}
        class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
        role="menuitem"
      >
        <Trophy class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500" />
        Your Certifications
      </a>
      <a
        href={`/users/${appStore.current_user.id}/edit`}
        class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
        role="menuitem"
      >
        <SquarePen
          class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500"
        />
        Account Settings
      </a>
      {#if appStore.current_user.admin === true}
        <a
          href="/admin"
          class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
        >
          <Lock class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500" />
          Administration
        </a>
      {/if}

      <a
        href={`/engagement-calculator`}
        class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
        role="menuitem"
        data-name="engagement-link"
      >
        <Calculator
          class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500"
        />
        Engagement Calculator
      </a>

      <a
        href={`/plans/new`}
        class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
        role="menuitem"
        data-name="create-new-plan"
      >
        <CirclePlus
          class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500"
        />
        Create New Plan
      </a>
      <a
        href="/users/sign_out"
        class="group flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        role="menuitem"
      >
        <LogOut class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500" />
        Log Out
      </a>
    </div>
  </div>
</Dropdown>
